import { makeStyles } from '@material-ui/core/styles'

const styles = () => ({
  container: {
    backgroundColor: '#FFEDF3',
    padding: 8,
    marginBottom: 8,
    flexWrap: 'nowrap',
  },
  icon: {
    marginRight: 8,
  },
})

export default makeStyles(styles)
